import './simple_modal_with_header.less';

import PropTypes from 'prop-types';

import React from 'react';
import classNames from 'classnames';
import BaseModal from './base_modal.jsx';

import { CloseIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';

const SimpleModalWithHeader = ({ title, subtitle, show, className, onRequestClose, children, ...props })=> (

  <BaseModal 
    {...props} 
    show={show === false ? false : true} 
    className={classNames(className, 'simple-modal-with-header')} 
    onRequestClose={onRequestClose}>
    <div className="simple-modal-header">

      <div className="title-container">{title}</div>
      {
        !subtitle ? null :
        <div className="subtitle-container">
          {subtitle}
        </div>
      }
      {
        props.hideCloseIcon ? null 
        :
        <CloseIcon className="close-container" onClick={onRequestClose} />
      }
    </div>
    <div className="simple-modal-with-header-body">
      {children}
    </div>
  </BaseModal>
);

SimpleModalWithHeader.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node
};

export default SimpleModalWithHeader;
